module.exports = __webpack_public_path__ + "img/invoice-header-ic.7fc7e522.svg";